import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'

export class PedidoService extends DataService {

  constructor() {
    super(false)
  }

  comprarNovamente(carrinho) {
    const options = {
      method: 'POST',
      url: '/carrinho/recarregar-carrinho',
      data: carrinho
    }

    return Observable
              .fromPromise(super.request(options));
  }

  getPosicaoAtualEntregador(codigoEntragor) {
    const options = {
      method: 'GET',
      url: '/pedido/mapa/' + codigoEntragor
    }

    return Observable
              .fromPromise(super.request(options));
  }

  verificaEstimativaEntrega() {
    let url = window.location.href
    let hash = url.split('pedido=')[1]

    const options = {
      method: 'GET',
      url: '/pedido/estimativaEntrega/' + hash
    }

    return Observable
              .fromPromise(super.request(options));    
  }

  verificaEstimativaEntregaListagem(hash) {
    const options = {
      method: 'GET',
      url: '/pedido/estimativaEntrega/' + hash
    }

    return Observable
              .fromPromise(super.request(options));    
  }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/minha-conta/pedido/pedido.service.js